import type { FormOptionType } from "@/components/ui/form/_types/type";

/**
 * 上限金額の設定に関する選択肢
 */
export const DiscountPriceTotalLimitOptions = [
	{ id: "none", label: "設定しない", value: "none" },
	{ id: "setting", label: "上限金額を設定する", value: "setting" },
] satisfies FormOptionType[];
